<template>
  <div v-if="showPopupBox" class="modal d-flex modal-background" tabindex="-1">
    <div class="modal-dialog popup-style">
      <div class="modal-content">
        <div class="modal-header border-0 align-items-start pb-0">
          <h1 class="modal-title text-center w-100 pt-3 p-4 pb-0" v-html="title" />
          <button
            type="button"
            class="btn-close btn-dismiss btn-round"
            @click="closeWithoutAction" />
        </div>
        <div class="modal-body p-3 pt-2 pb-3">
          <div class="text-center item-normal" v-html="content" />
        </div>
        <div class="modal-footer justify-content-center border-0 pt-0">
          <button
            v-if="secondaryText"
            type="button"
            class="btn btn-booster-secondary btn-foot float-start"
            :class="{'col': secondaryText}"
            @click="closePopupBoxOnSecondaryBtn"
            v-html="secondaryText" />
          <button
            type="button"
            class="btn btn-booster-primary btn-foot"
            :class="{'col': secondaryText, 'float-end': secondaryText}"
            @click="closePopupBox"
            v-html="okay" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PopupBox",
  props: {
    title: {type: String, default: ""},
    content: {type: String, default: ""},
    okay: {type: String, default: "Okay"},
    secondaryText: {type: String, default: ""},
    showPopupBox: {type: Boolean, default: false}
  },
  emits: ["update:showPopupBox", "primaryBtnAction", "secondaryBtnAction"],
  methods: {
    closePopupBox() {
      this.$emit("primaryBtnAction");
      this.$emit("update:showPopupBox", false);
    },
    closePopupBoxOnSecondaryBtn() {
      this.$emit("secondaryBtnAction");
      this.$emit("update:showPopupBox", false);
    },
    closeWithoutAction() {
      this.$emit("update:showPopupBox", false);
    }
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/scss/shared-styles.scss";

.modal {
  flex-direction: column;
  justify-content: center;
}

.btn-dismiss {
  position: absolute;
  right: 1rem;
  top: 15px;
  font-size: 10px;
  border-radius: 50%;
  background-color: #eaeaea;
  opacity: 0.6;
}

.popup-style {
  width: 18.5rem;
}

.modal-background {
  background:rgba(0, 0, 0, 0.50);
}

.modal-title {
  color: $booster-text;
  text-align: center;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
}
.modal-body {
  .item-normal {
    color: $booster-text;
    text-align: center;
    font-family: "Nunito Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
}
.modal-footer {
  .btn {
    min-height: 2.25rem;
    height: 2.25rem;
  }
}
</style>
